import { gql } from "@apollo/client";

const PUBLISHED_SCRIPTBOOK_FILES_QUERY = gql`
  query changelist {
    changelist {
      id
      files {
        path
      }
    }
  }
`;

const PUBLISHED_SCRIPTBOOK_IMPORTS_QUERY = gql`
  query published_source_bundles($first: Int, $can_backfill: Boolean) {
    source_bundles(first: $first) {
      edges {
        node {
          id
          status
          bundle_name
          tables(can_backfill: $can_backfill) {
            id
            name
            project
            credential {
              name
              status
            }
          }
        }
      }
    }
  }
`;

const PUBLISHED_SCRIPTBOOK_EXPORTS_QUERY = gql`
  query export_declarations($first: Int) {
    export_declarations(first: $first) {
      edges {
        node {
          name
          project
          status
          credential {
            name
            status
          }
          destination
        }
      }
    }
  }
`;

const PUBLISHED_SCRIPTBOOK_GET_LINKS = gql`
  query export_declaration($name: String) {
    export_declaration(name: $name) {
      name
      subgraph {
        download_declarations {
          bundle_name
          tables {
            name
            exports {
              name
            }
          }
        }
        upload_declarations {
          name
        }
      }
    }
  }
`;

const PUBLISHED_SCRIPTBOOK_ASSETS_QUERY = gql`
  query suspended_assets_query($first: Int) {
    changelist {
      id
    }
    credentials(first: $first) {
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        cursor
        node {
          name
          credential_type
          status
        }
      }
    }
    export_declarations(first: $first) {
      edges {
        node {
          id
          name
          project
          line
          status
          credential {
            name
            status
          }
        }
      }
    }
    source_bundles(first: $first) {
      edges {
        node {
          id
          status
          tables {
            id
            name
            line
            project
            exports {
              name
            }
            credential {
              name
              status
            }
          }
        }
      }
    }
  }
`;

export {
  PUBLISHED_SCRIPTBOOK_ASSETS_QUERY,
  PUBLISHED_SCRIPTBOOK_EXPORTS_QUERY,
  PUBLISHED_SCRIPTBOOK_FILES_QUERY,
  PUBLISHED_SCRIPTBOOK_GET_LINKS,
  PUBLISHED_SCRIPTBOOK_IMPORTS_QUERY,
};
